import { EVENT_TYPE, UPLOAD_CSV_TYPE } from "../config/constants";

import { Dispatch } from "react";
import ShiftDetailPage from "../components/pages/shiftDetail/ShiftDetailPage";
import actions from "../redux/actions/Index";
import { connect } from "react-redux";

export const mapStateToProps = (state: any, props: any) => {
  return {
    isWarehouseListLoading: state.product.isLoading,
    warehouseList: state.product.wareHouseNames,
    isLoading: state.warehouseOps.isLoading,
    isError: state.warehouseOps.isError,
    error: state.warehouseOps.error,
    isWarehouseShiftStarted: state.warehouseOps.isWarehouseShiftStarted,
    warehouseShiftId: state.warehouseOps.warehouseShiftId,
    isTourAdded: state.warehouseOps.isTourAdded,
    isTourCsvUploaded: state.warehouseOps.isTourCsvUploaded,
    isWarehouseShiftEnded: state.warehouseOps.isShiftEnded,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    getWarehouses: () => dispatch(actions.fetchWareHouseNames()),
    startWarehouseShift: (warehouseId: string) =>
      dispatch(actions.startWarehouseShift(warehouseId)),
    endWarehouseShift: (shiftId: string, eventType: EVENT_TYPE) =>
      dispatch(actions.endWarehouseShift(shiftId, eventType)),
    uploadTourAndUpdateShiftEvent: (
      shiftId: string,
      eventType: EVENT_TYPE,
      uploadType: UPLOAD_CSV_TYPE,
      payload: FormData,
      warehouseId: string
    ) =>
      dispatch(
        actions.uploadTourCsvForWarehouseShiftAndUpdateShiftEvent(
          shiftId,
          eventType,
          uploadType,
          payload,
          warehouseId
        )
      ),
  };
};

const ShiftDetailContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ShiftDetailPage);
export default ShiftDetailContainer;
